/**
 * Class description
 *
 * Created: 2017-09-25
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {TeslaParsedGameData} from "../../server/data/TeslaParsedGameData";
import {TeslaParsedInitData} from "../../server/data/TeslaParsedInitData";
import {Tesla} from "../../Tesla";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";
import {TeslaLightGroup} from "./TeslaLightGroup";


export class TeslaWildCollectIndicatorView extends BaseView {

    private _lightGroups:TeslaLightGroup[];
    private _backPlate:PIXI.Sprite;
    private _boxAnimation:TimelineSprite;
    private _isRestoreState:boolean;
    private _initWildsCollected:number[];

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected initAnimations():void {
        this._backPlate = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.COLLECT_BOX_BACKPLATE)[0]);
        this._backPlate.anchor.set(0.5, 0);
        this._backPlate.position.set(0, 8);
        this.addChild(this._backPlate);


        this._boxAnimation = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.COLLECT_BOX_COVER), 30);
        this.addChild(this._boxAnimation);
        this._boxAnimation.anchor.set(0.5, 0);

        this._lightGroups = [
            new TeslaLightGroup(),
            new TeslaLightGroup(),
            new TeslaLightGroup()
        ];

        this._lightGroups[0].position.set(-187, -35);
        this._lightGroups[1].position.set(-46, -35);
        this._lightGroups[2].position.set(88, -35);

        for(let i:number = 0; i < this._lightGroups.length; i++) {
            let lightGroup:TeslaLightGroup = this._lightGroups[i];
            this._backPlate.addChild(lightGroup);

        }


    }

    private onInitDataParsed(data:TeslaParsedInitData) {
        this._isRestoreState = data.isRestoreState;
        this._initWildsCollected = data.wildsCollected

    }

    private onGameDataParsed(data:TeslaParsedGameData) {
        if(this._isRestoreState) {
            this._isRestoreState = false;
            const tl:TimelineLite = new TimelineLite();
            tl.add(this.getWinAnimation(this._initWildsCollected, true));

        }

    }

    public getWinAnimation(wildsCollected:number[], isRestore?:boolean):TimelineLite[] {
        let group1Tl = this._lightGroups[0].getLightAnimations(wildsCollected[1], isRestore);
        let group2Tl = this._lightGroups[1].getLightAnimations(wildsCollected[2], isRestore);
        let group3Tl = this._lightGroups[2].getLightAnimations(wildsCollected[3], isRestore);

        return [...group1Tl, ...group2Tl, ...group3Tl];
    }

    public getBounceAnimation(wildsCollected:number[], reel:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._lightGroups[reel - 1].getLightAnimations(wildsCollected[reel]));
        return tl;
    }

    public getIntro(restoreState:boolean = false):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if(restoreState) {
            tl.add([
                () => this._boxAnimation.setFrame(this._boxAnimation.totalFrames - 1),
                new TweenLite(this._backPlate, 0.001, {y : 0}),
            ])
        } else {
            tl.add([
                this._boxAnimation.getAnimation(),
                () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_PANEL_COVER)
            ], 1);
            tl.add([
                new TweenLite(this._backPlate, 1, {y : 0}),
                () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_PANEL_UP)
            ]);
            const startTime = tl.totalDuration();
            for(let i:number = 0; i < this._lightGroups.length; i++) {
                let lightGroup:TeslaLightGroup = this._lightGroups[i];
                tl.add(lightGroup.getIntro(), startTime + (0.13 * i) * 3);
            }
        }
        return tl;
    }


    public getOutro():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._backPlate, 1, {y : 8}),
            () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_PANEL_UP)
        ]);
        tl.add([
            this._boxAnimation.getAnimation([this._boxAnimation.totalFrames - 1, 0]),
            () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_PANEL_COVER)
        ]);

        return tl;
    }
}